import { IPaginateData, IResponse, Model, ObjectsFactory } from '@/data'
import { NOTIFICATIONS_ENDPOINT } from '@/data/endpoint'
import { INotification } from '@/types'

export interface IUnreadCountResponse {
  count: number
}

export class Notification extends Model {
  static config = { endpoint: NOTIFICATIONS_ENDPOINT }

  static objects = ObjectsFactory.factory<INotification>(Notification.config)

  static async getNotifications(params?: { take?: number; skip?: number; walletAddresses: string[] }) {
    return await this.service.get<IPaginateData<INotification>>({
      url: NOTIFICATIONS_ENDPOINT,
      params,
    })
  }

  static async getUnreadCount(params: { walletAddresses: string[] }) {
    return await this.service.get<IResponse<IUnreadCountResponse>>({
      url: `${NOTIFICATIONS_ENDPOINT}/unread-count`,
      params,
    })
  }

  static async markAsRead(id: number, payload: { walletAddresses: string[] }) {
    return await this.service.post<IResponse<void>>({
      url: `${NOTIFICATIONS_ENDPOINT}/${id}/read`,
      payload,
    })
  }

  static async markAllAsRead(payload: { walletAddresses: string[] }) {
    return await this.service.post<IResponse<void>>({
      url: `${NOTIFICATIONS_ENDPOINT}/mark-all-read`,
      payload,
    })
  }
}

Notification.init(Notification.config)
